{
  "name": "@blockdaemon/widget-ui",
  "version": "0.1.3",
  "private": true,
  "workspaces": [
    "packages/*",
    "apps/*"
  ],
  "type": "module",
  "scripts": {
    "dev": "node ./scripts/dev-all.mjs",
    "dev:showcase": "node ./scripts/dev.mjs",
    "dev:earn": "PORTLESS_APP_NAME=earn.widget WIDGET_DEV_ROOT=apps/earn-widget WIDGET_DEV_TITLE=\"Blockdaemon Earn Widget\" node ./scripts/dev.mjs",
    "dev:tokenization": "PORTLESS_APP_NAME=tokenization.widget WIDGET_DEV_ROOT=apps/tokenization-widget WIDGET_DEV_TITLE=\"Blockdaemon Tokenization Widget\" node ./scripts/dev.mjs",
    "build": "bun run validate:config && bun run i18n:compile && bun run build:showcase && bun run build:earn && bun run build:tokenization",
    "build:showcase": "cd apps/widget-showcase && bunx tsc -b && VITE_WIDGET_ONLY= bunx vite build",
    "build:earn": "cd apps/earn-widget && bunx tsc -b && bunx vite build",
    "build:tokenization": "cd apps/tokenization-widget && bunx tsc -b && bunx vite build",
    "build:with-docs": "bun run build && bun run docs:build",
    "build:preview": "bun run build && bun run preview",
    "build:preview:ci": "bun run build && bun run preview:ci",
    "preview": "node ./scripts/preview.mjs",
    "preview:earn": "cd apps/earn-widget && bunx vite preview --port 5173",
    "preview:tokenization": "cd apps/tokenization-widget && bunx vite preview --port 5174",
    "preview:ci": "cd apps/widget-showcase && bunx vite preview --host 127.0.0.1 --port 3000 --strictPort",
    "typecheck": "bunx tsc --noEmit -p apps/widget-showcase/tsconfig.json && bunx tsc --noEmit -p apps/earn-widget/tsconfig.json && bunx tsc --noEmit -p apps/tokenization-widget/tsconfig.json && bunx tsc --noEmit -p apps/tokenization-widget/tsconfig.node.json && bunx tsc --noEmit -p apps/widget-docs/tsconfig.json && bunx tsc --noEmit -p packages/widget-metadata/tsconfig.json && bunx tsc --noEmit -p packages/widget-host/tsconfig.json && bunx tsc --noEmit -p packages/widget-config/tsconfig.json && bunx tsc --noEmit -p packages/widget-worker/tsconfig.json && bunx tsc --noEmit -p packages/widget-shell/tsconfig.json && bunx tsc --noEmit -p packages/widget-tooling/tsconfig.json",
    "analyze": "bun run scripts/bundle-analyzer.ts",
    "audit": "bun audit --ignore=GHSA-rmmr-r34h-pfm5 --ignore=GHSA-3gc7-fjrx-p6mg --audit-level=high",
    "duplication": "jscpd",
    "knip": "knip",
    "lint": "oxlint . && oxfmt --check --ignore-path=.oxfmtignore --ignore-path=.gitignore .",
    "lint:fix": "oxlint . --fix && oxfmt --ignore-path=.oxfmtignore --ignore-path=.gitignore .",
    "quality": "bun run lint && bun run knip && bun run duplication && bun run test",
    "postinstall": "sh scripts/install-hooks.sh && bun run sync:skills",
    "routes:generate": "cd apps/earn-widget && bun run routes:generate",
    "i18n:extract": "lingui extract --config ./lingui.config.js --clean",
    "i18n:compile": "lingui compile --config ./lingui.config.js --strict --verbose",
    "storybook": "node ./scripts/storybook.mjs",
    "storybook:build": "bun run docs:clean && cd apps/widget-docs && STORYBOOK_DISABLE_TELEMETRY=1 bunx storybook build -o dist",
    "storybook:preview": "bun run storybook:build && node ./scripts/storybook-preview.mjs",
    "docs:clean": "rm -rf apps/widget-docs/dist",
    "docs:build": "bun run storybook:build",
    "test": "bun run validate:config && bun test scripts apps/earn-widget/src apps/tokenization-widget/src apps/widget-docs/docs packages/widget-host/src tests/functions --timeout 10000",
    "test:coverage": "bun run validate:config && bun test --coverage scripts apps/earn-widget/src apps/tokenization-widget/src apps/widget-docs/docs packages/widget-host/src tests/functions --timeout 10000",
    "test:watch": "bun test --watch scripts apps/earn-widget/src apps/tokenization-widget/src apps/widget-docs/docs packages/widget-host/src tests/functions --timeout 10000",
    "test:e2e": "CI= BASE_URL=${BASE_URL:-https://preview.widget.localhost:3000} playwright test -c tests/playwright.config.ts --timeout=90000",
    "test:e2e:ci": "BASE_URL=${BASE_URL:-http://127.0.0.1:3000} playwright test -c tests/playwright.config.ts --timeout=90000",
    "test:e2e:ui": "playwright test -c tests/playwright.config.ts --ui",
    "test:e2e:headed": "playwright test -c tests/playwright.config.ts --headed",
    "test:wallet": "bunx prepare-metamask && playwright test -c tests/playwright-wallet.config.ts",
    "test:wallet:staking": "bunx prepare-metamask && playwright test -c tests/playwright-wallet.config.ts tests/wallet/features/staking/",
    "test:wallet:ui": "bunx prepare-metamask && playwright test -c tests/playwright-wallet.config.ts --ui",
    "test:component": "playwright test -c tests/playwright-ct.config.ts",
    "test:component:ui": "playwright test -c tests/playwright-ct.config.ts --ui",
    "test:playwright": "bun run test:e2e && bun run test:wallet && bun run test:component",
    "clean": "rm -rf dist node_modules/.vite .wrangler",
    "clean:full": "rm -rf dist node_modules bun.lock .wrangler && bun install",
    "generate:schema": "bun run scripts/generate-json-schema.ts",
    "validate:config": "bun run scripts/validate-config.ts",
    "validate:skills": "bun run scripts/validate-skill-links.ts",
    "sync:skills": "bun run scripts/sync-skill-links.ts",
    "lint:react-doctor": "bunx react-doctor . --yes --offline"
  },
  "dependencies": {
    "@blockdaemon/widget-metadata": "workspace:*",
    "@blockdaemon/widget-worker": "workspace:*"
  },
  "devDependencies": {
    "@axe-core/playwright": "4.11.3",
    "@blockdaemon-internal/design-system": "1.0.7",
    "@coinbase/onchaintestkit": "1.2.1",
    "@currents/playwright": "2.0.0-beta.3",
    "@lingui/cli": "6.0.1",
    "@lingui/format-po": "6.0.1",
    "@lingui/vite-plugin": "6.0.1",
    "@playwright/experimental-ct-react": "1.60.0",
    "@playwright/test": "1.60.0",
    "@rolldown/plugin-babel": "0.2.3",
    "@semantic-release/exec": "7.1.0",
    "@tanstack/react-query": "5.100.10",
    "@types/bun": "1.3.14",
    "@types/react": "19.2.14",
    "@types/react-dom": "19.2.3",
    "http-server": "14.1.1",
    "jose": "6.2.3",
    "jscpd": "4.2.0",
    "knip": "6.13.1",
    "oxfmt": "0.50.0",
    "oxlint": "1.65.0",
    "portless": "0.13.0",
    "puppeteer": "25.0.2",
    "react": "19.2.6",
    "react-compiler-runtime": "1.0.0",
    "react-doctor": "0.1.6",
    "react-dom": "19.2.6",
    "typescript": "6.0.3",
    "vite": "8.0.13",
    "zod": "4.4.3"
  },
  "overrides": {
    "@tanstack/query-core": "5.100.10",
    "@tanstack/router-core": "1.169.2",
    "axios": "1.15.2",
    "base-x": "^4.0.0",
    "basic-ftp": "5.3.1",
    "cookie": "^0.7.2",
    "defu": "6.1.7",
    "devalue": "^5.3.2",
    "diff": "^8.0.3",
    "dompurify": "3.4.0",
    "elliptic": "npm:@soatok/elliptic-to-noble@9999.0.0",
    "esbuild": "^0.25.6",
    "flatted": "^3.4.0",
    "follow-redirects": "1.16.0",
    "form-data": "^4.0.4",
    "glob": "^10.5.0",
    "got": "^13.0.0",
    "h3": "^1.15.6",
    "hono": "4.12.18",
    "js-yaml": "^4.1.1",
    "lodash": "4.18.1",
    "lodash-es": "4.18.1",
    "mermaid": "11.15.0",
    "minimatch": "^9.0.7",
    "picomatch": "4.0.4",
    "preact": "10.28.2",
    "protobufjs": "7.5.6",
    "secp256k1": "^4.0.4",
    "socket.io-parser": "^4.2.6",
    "tar": "^7.5.7",
    "tar-fs": "^3.0.6",
    "tough-cookie": "^4.1.3",
    "tsup": "^8.3.5",
    "undici": "^6.24.0",
    "viem": "2.49.2",
    "ws": "^8.18.0"
  },
  "engines": {
    "bun": ">=1.3.0",
    "node": ">=24.0.0"
  },
  "catalog": {
    "@blockdaemon-internal/design-system": "1.0.7",
    "@blockdaemon-internal/widget-react": "1.4.1",
    "@blockdaemon/bd-sdk": "0.19.0",
    "@cloudflare/vite-plugin": "1.37.1",
    "@cloudflare/workers-types": "4.20260511.1",
    "@emotion/react": "11.14.0",
    "@lingui/babel-plugin-lingui-macro": "6.0.1",
    "@lingui/core": "6.0.1",
    "@lingui/react": "6.0.1",
    "@lingui/vite-plugin": "6.0.1",
    "@mantine/core": "8.2.1",
    "@mantine/emotion": "8.2.2",
    "@mantine/hooks": "8.2.1",
    "@mantine/spotlight": "8.2.1",
    "@reown/appkit": "1.8.19",
    "@reown/appkit-adapter-solana": "1.8.19",
    "@reown/appkit-adapter-wagmi": "1.8.19",
    "@reown/appkit-common": "1.8.19",
    "@rolldown/plugin-babel": "0.2.3",
    "@sentry/react": "10.53.1",
    "@solana/web3.js": "1.98.4",
    "@storybook/addon-docs": "10.4.0",
    "@storybook/addon-links": "10.4.0",
    "@storybook/react-vite": "10.4.0",
    "@tabler/icons-react": "3.44.0",
    "@tanstack/react-form": "1.32.0",
    "@tanstack/react-query": "5.100.10",
    "@tanstack/react-query-devtools": "5.100.10",
    "@tanstack/react-router": "1.169.2",
    "@tanstack/react-router-devtools": "1.166.13",
    "@tanstack/router-cli": "1.166.43",
    "@tanstack/router-plugin": "1.167.35",
    "@tanstack/zod-adapter": "1.166.9",
    "@types/node": "25.8.0",
    "@types/react": "19.2.14",
    "@types/react-dom": "19.2.3",
    "@vitejs/plugin-react": "6.0.2",
    "@wagmi/connectors": "8.0.14",
    "@wagmi/core": "3.4.12",
    "babel-plugin-react-compiler": "1.0.0",
    "buffer": "6.0.3",
    "bun-types": "1.3.14",
    "dayjs": "1.11.20",
    "hono": "4.12.18",
    "jose": "6.2.3",
    "ky": "2.0.2",
    "lightningcss": "1.32.0",
    "lucide-react": "1.16.0",
    "mdx-mermaid": "2.0.3",
    "mermaid": "11.15.0",
    "motion": "12.38.0",
    "posthog-js": "1.373.5",
    "react": "19.2.6",
    "react-dom": "19.2.6",
    "remark-gfm": "4.0.1",
    "rollup-plugin-visualizer": "7.0.1",
    "storybook": "10.4.0",
    "typescript": "6.0.3",
    "viem": "2.49.2",
    "vite": "8.0.13",
    "wagmi": "3.6.15",
    "wrangler": "4.92.0",
    "zod": "4.4.3"
  },
  "patchedDependencies": {
    "@coinbase/onchaintestkit@1.2.1": "patches/@coinbase%2Fonchaintestkit@1.2.1.patch",
    "@tanstack/router-plugin@1.167.22": "patches/@tanstack%2Frouter-plugin@1.167.22.patch"
  },
  "trustedDependencies": []
}
